var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-nav"}},[_c('ul',{staticClass:"top-nav-container"},[(_vm.loggedIn)?_c('NavBarRoutes',{attrs:{"routes":_vm.loggedInNavRoutes,"top":true}}):_c('NavBarRoutes',{attrs:{"routes":_vm.loggedOutNavRoutes,"top":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }